<template>
	<div>
		<div class="topPart">
			<div class="return" @click="CommentReturn"></div>
			<a href="https://m.tunnelling.cn/Manager/MemberIndex.aspx"><img :src="imgUrl" alt="" /></a>
		</div>
		<DownloadChapter :downloadWay="downloadWay" :chapterId="chapterFirstId" :goods="Goods" :sellWayText="sell" />
	</div>
</template>

<script>
import DownloadChapter from '../../components/DownloadChapter.vue'
export default{
	name: 'BookPayment',
	data(){
		return{
			downloadWay:undefined,  // 支付类型
			InformationId:undefined,  // 情报id
			contentId:undefined,  // 章节id
			chapterFirstId:undefined,  // 整章购买时，需要章节第一个id
			Goods:{},  // 商品
			imgUrl:'',  // 头像
			sell:undefined,  // 价格(-1)
		}
	},
	created() {
		// 获取类型
		this.downloadWay = this.$route.query.type - 0;
		// 情报id
		this.InformationId = this.$route.query.InformationId;
		// 章节id
		this.contentId = this.$route.query.id;
		// 整章购买时，需要章节第一个id
		this.chapterFirstId = this.$route.query.chapterId;
		// 提示文字
		this.sell = this.$route.query.sellway;
		// 商品
		if(this.downloadWay == 1){
			this.GetGoods();
		}else{ 
			this.GetChapterBuy();
		}
		// 获取用户信息
		this.GetUserInfo();
	},
	methods:{
		// 获取商品-整书
		GetGoods(){
			this.$fetch('/api/information/goods/?id='+this.InformationId)
			.then((res)=>{
				this.Goods = res.data;
				// 判断是否为微信浏览器
				this.JugeWx(res.data.id)
			}).catch((err)=>{
				throw err;
			});
		},
		// 获取情报里的内容商品
		GetChapterBuy(){
			this.$fetch('/api/information/'+this.InformationId+'/informationContent/goods/?id='+this.contentId)
			.then((res)=>{
				this.Goods = res.data;
				// 判断是否为微信浏览器
				this.JugeWx(res.data.id)
			}).catch((err)=>{
				throw err;
			});
		},
		// 微信浏览器
		WeChatFn(goodsId){
			let code = this.GetQueryString('code'); // 获取微信授权码
			code = code ? code : ''; // code为undefined传空字符串
			let url = Const_Api_Root + "/wx_redirect.html";
			let params = {
				"code": code, // 授权码
				"redirectUrl": encodeURIComponent(url), // 授权后重定向的页面
				"state":encodeURIComponent(location.hash),
				"paymentWay": "微信",
				"goodsId": goodsId, // 商品号
				"quantity": 1 ,// 数量
				"SucceededUrl":Const_Api_Root+"/index.html#/paySuccess",
				"FailedUrl":Const_Api_Root+"/index.html#/payError"
			};
			this.$post('/api/payment',params)
			.then((res)=>{
				// 授权地址不为空跳转到授权页面
				if (!code && res.data.authorizationUrl) {
				    location.href = res.data.authorizationUrl;
				}
			}).catch((err)=>{
				throw err;
			});
		},
		// 判断是否是微信浏览器
		JugeWx(goodsId){
			var ua = navigator.userAgent.toLowerCase();
			let code = this.GetQueryString('code'); // 获取微信授权码
			if(ua.match(/MicroMessenger/i)=="micromessenger") {
		        if(code) return
		        this.WeChatFn(goodsId)
			}
		},
		GetQueryString(name) {
			var result = location.href.match(new RegExp("[\?\&]" + name+ "=([^\&]+)","i"));
			if(result == null || result.length < 1){
				return "";
			}
			return result[1];
		},
		// 获取用户信息
		GetUserInfo(){
			this.$fetch('/Login')
			.then((res)=>{
				if(res.data.accessAllowed === false) return;
				this.imgUrl = res.data.imagePath;
			}).catch((err)=>{
				throw err;
			});
		},
		// 返回
		CommentReturn(){
			this.$router.go(-1);
		}
	},
	components:{
		DownloadChapter
	}
}
</script>

<style scoped>
.topPart{
	width: 100%;
	height: .88rem;
	display: flex;
	align-items: center;
	justify-content: flex-end;
	position: relative;
}
.topPart img{
	width: .6rem;
	height: .6rem;
	border-radius: 50%;
	margin-right: .25rem;
}
.topPart .return{
	width: .4rem;
	height: .4rem;
	background: url(../../assets/img/return_mobile.svg) no-repeat;
	background-size: 100% 100%;
	position: absolute;
	left: .25rem;
	top: 50%;
	transform: translateY(-50%);
}
</style>



// WEBPACK FOOTER //
// src/pages/BookDetails/BookPayment.vue